<template>
  <v-data-table
    dense
    :headers="headers"
    :items="productosTabla"
    item-key="Referencia"
    :hide-default-footer="true"
    class=""
  >
    <template #item.actions="{ item }">
      <v-icon size="16" @click="deleteItem(item)">
        $fi-trash-2
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: {
    headers: {
      type: Array,
      default: new Array(),
      cargando: false,
    },
    productosTabla: {
      type: Array,
      default: new Array(),
      cargando: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    deleteItem(item) {
      this.$emit("deleteItem", item);
    },
  },
};
</script>
